import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {finalize} from "rxjs/operators";
import {LoadingService} from "../services/loading.service";

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

    totalRequests = 0;
    requestsCompleted = 0;

    constructor(private loadingService: LoadingService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loadingService.startLoading();
        this.totalRequests++;

        return next.handle(request).pipe(
            finalize(() => {
                this.requestsCompleted++;
                if (this.requestsCompleted === this.totalRequests) {
                    this.loadingService.finishLoading();
                    this.totalRequests = 0;
                    this.requestsCompleted = 0;
                }
            })
        );
    }
}
